export const FETCH_USER_UPDATE_PROFILE_REQUEST = 'FETCH_USER_UPDATE_PROFILE_REQUEST';
export const FETCH_USER_UPDATE_PROFILE_SUCCESS = 'FETCH_USER_UPDATE_PROFILE_SUCCESS';
export const FETCH_USER_UPDATE_PROFILE_FAILURE = 'FETCH_USER_UPDATE_PROFILE_FAILURE';

export const FETCH_USER_UPDATE_USERNAME_REQUEST = 'FETCH_USER_UPDATE_USERNAME_REQUEST';
export const FETCH_USER_UPDATE_USERNAME_SUCCESS = 'FETCH_USER_UPDATE_USERNAME_SUCCESS';
export const FETCH_USER_UPDATE_USERNAME_FAILURE = 'FETCH_USER_UPDATE_USERNAME_FAILURE';
export const RESET_USER_UPDATE_USERNAME_STATE = 'RESET_USER_UPDATE_USERNAME_STATE';

export const FETCH_USER_FORGOT_PASSWORD_REQUEST = 'FETCH_USER_FORGOT_PASSWORD_REQUEST';
export const FETCH_USER_FORGOT_PASSWORD_SUCCESS = 'FETCH_USER_FORGOT_PASSWORD_SUCCESS';
export const FETCH_USER_FORGOT_PASSWORD_FAILURE = 'FETCH_USER_FORGOT_PASSWORD_FAILURE';
export const RESET_USER_FORGOT_PASSWORD_STATE = 'RESET_USER_FORGOT_PASSWORD_STATE';

export const FETCH_USER_RESET_PASSWORD_REQUEST = 'FETCH_USER_RESET_PASSWORD_REQUEST';
export const FETCH_USER_RESET_PASSWORD_SUCCESS = 'FETCH_USER_RESET_PASSWORD_SUCCESS';
export const FETCH_USER_RESET_PASSWORD_FAILURE = 'FETCH_USER_RESET_PASSWORD_FAILURE';
export const RESET_USER_RESET_PASSWORD_STATE = 'RESET_USER_RESET_PASSWORD_STATE';

export const FETCH_USER_LIST_REQUEST = 'FETCH_USER_LIST_REQUEST';
export const FETCH_USER_LIST_SUCCESS = 'FETCH_USER_LIST_SUCCESS';
export const FETCH_USER_LIST_FAILURE = 'FETCH_USER_LIST_FAILURE';
export const RESET_USER_LIST_STATE = 'RESET_USER_LIST_STATE';

export const FETCH_ROLE_LIST_REQUEST = 'FETCH_ROLE_LIST_REQUEST';
export const FETCH_ROLE_LIST_SUCCESS = 'FETCH_ROLE_LIST_SUCCESS';
export const FETCH_ROLE_LIST_FAILURE = 'FETCH_ROLE_LIST_FAILURE';

export const FETCH_MANAGE_ROLE_REQUEST = 'FETCH_MANAGE_ROLE_REQUEST';
export const FETCH_MANAGE_ROLE_SUCCESS = 'FETCH_MANAGE_ROLE_SUCCESS';
export const FETCH_MANAGE_ROLE_FAILURE = 'FETCH_MANAGE_ROLE_FAILURE';

export const FETCH_GET_BALANCE_REQUEST = 'FETCH_GET_BALANCE_REQUEST';
export const FETCH_GET_BALANCE_SUCCESS = 'FETCH_GET_BALANCE_SUCCESS';
export const FETCH_GET_BALANCE_FAILURE = 'FETCH_GET_BALANCE_FAILURE';
export const SET_BALANCE = 'SET_BALANCE';

export const FETCH_CHECK_EMAIL_EXIST_REQUEST = 'FETCH_CHECK_EMAIL_EXIST_REQUEST';
export const FETCH_CHECK_EMAIL_EXIST_SUCCESS = 'FETCH_CHECK_EMAIL_EXIST_SUCCESS';
export const FETCH_CHECK_EMAIL_EXIST_FAILURE = 'FETCH_CHECK_EMAIL_EXIST_FAILURE';

export const FETCH_CHECK_USERNAME_EXIST_REQUEST = 'FETCH_CHECK_USERNAME_EXIST_REQUEST';
export const FETCH_CHECK_USERNAME_EXIST_SUCCESS = 'FETCH_CHECK_USERNAME_EXIST_SUCCESS';
export const FETCH_CHECK_USERNAME_EXIST_FAILURE = 'FETCH_CHECK_USERNAME_EXIST_FAILURE';

export const FETCH_RESEND_VERIFICATION_REQUEST = 'FETCH_RESEND_VERIFICATION_REQUEST';
export const FETCH_RESEND_VERIFICATION_SUCCESS = 'FETCH_RESEND_VERIFICATION_SUCCESS';
export const FETCH_RESEND_VERIFICATION_FAILURE = 'FETCH_RESEND_VERIFICATION_FAILURE';
export const FETCH_RESEND_VERIFICATION_RESET = 'FETCH_RESEND_VERIFICATION_RESET';

export const FETCH_ALL_PLAYER_REQUEST = 'FETCH_GET_BALANCE_REQUEST';
export const FETCH_ALL_PLAYER_SUCCESS = 'FETCH_GET_BALANCE_SUCCESS';
export const FETCH_ALL_PLAYER_FAILURE = 'FETCH_ALL_PLAYER_FAILURE';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';

export const FETCH_LOG_OUT_DETAIL_REQUEST = 'FETCH_LOG_OUT_DETAIL_REQUEST';
export const FETCH_LOG_OUT_DETAIL_SUCCESS = 'FETCH_LOG_OUT_DETAIL_SUCCESS';
export const FETCH_LOG_OUT_DETAIL_FAILURE = 'FETCH_LOG_OUT_DETAIL_FAILURE';

export const FETCH_USER_INFO_REQUEST = 'FETCH_USER_INFO_REQUEST';
export const FETCH_USER_INFO_SUCCESS = 'FETCH_USER_INFO_SUCCESS';
export const FETCH_USER_INFO_FAILURE = 'FETCH_USER_INFO_FAILURE';
